import { render } from "./ListeRegionPage.vue?vue&type=template&id=d4af5a90&ts=true"
import script from "./ListeRegionPage.vue?vue&type=script&lang=ts"
export * from "./ListeRegionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__